import {HttpClient} from '@angular/common/http';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {appConfig} from '../../../shared/app.config';
import {catchError} from 'rxjs/operators';
import {AssetLien} from '../../../shared/domain/item';


@Injectable({
  providedIn: 'root'
})
export class AssetLienService {

  constructor(private http: HttpClient) {

  }

  public createNewLien(assetLienDtos: AssetLien[], isBlanket: 'Y'|'N'): Observable<any> {
    const url = '/api/createNewLien?isBlanket=' + isBlanket + '&acgId=' + assetLienDtos[0].acgId;
    console.log(url, 'url');
    const body = JSON.stringify(assetLienDtos);
    return this.http.post(url, body, appConfig.httpOptions);
  }

  public getBlanketLienDetails(acgId): Observable<any> {
    let url = '/api/asset-package/:acgId/blanket-liens';
    url = url.replace(':acgId', String(acgId));
    return this.http.get<any>(url, appConfig.httpOptions);
  }

  public deleteLien(lienId): Observable<any> {
    let url = '/api/lien/{lienId}/delete-lien';
    url = url.replace('{lienId}', String(lienId));
    return this.http.delete<any>(url, appConfig.httpOptions).pipe(
      catchError(HttpRequestErrorHandler.handleError('remove asset liens', null))
    );
  }

  public updateAssetLienFlag(assetId, lienYn): Observable<any> {
    let url = '/api/asset/{assetId}/lienYn/{lienYn}/updateAssetLienFlag';
    url = url.replace('{assetId}', String(assetId));
    url = url.replace('{lienYn}', lienYn);
    return this.http.put(url, appConfig.httpOptions);
  }
}
